import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { Institution } from '@shared/services/refunds/types/getRefundsInstitutions.type';

import { initialState } from './initialState';
import type { RefundsState } from './types';
import type { RefundDraft, RefundsPatientDetails, RefundSummaryInfo } from '../types/refunds.types';

const refundsSlice = createSlice({
  initialState,
  name: 'Refunds',
  reducers: {
    setSelectedPatient: (state, action: PayloadAction<RefundsPatientDetails>) => {
      state.selectedPatient = action.payload;
    },
    setSelectedInstitution: (state, action: PayloadAction<Institution>) => {
      state.selectedInstitution = action.payload;
    },
    setRefundDetails: (state, action: PayloadAction<RefundsState['refundDetails']>) => {
      state.refundDetails = { ...state.refundDetails, ...action.payload };
    },
    setRefundSummaryInfo: (state, action: PayloadAction<RefundSummaryInfo>) => {
      state.refundSummaryInfo = action.payload;
    },
    setRefundSubmitStatus: (state, action: PayloadAction<RefundsState['refundSubmitStatus']>) => {
      state.refundSubmitStatus = { ...state.refundSubmitStatus, ...action.payload };
    },
    setRefundDraft: (state, action: PayloadAction<RefundDraft>) => {
      state.refundDraft = action.payload;
    },
    setIsEditing(state, action: PayloadAction<boolean>) {
      state.isEditing = action.payload;
    },
    clearIsEditing(state) {
      state.isEditing = false;
    },
    clearRefundDraft: (state) => {
      state.refundDraft = null;
    },
    clearRefundSummaryInfo: (state) => {
      state.refundSummaryInfo = null;
    },
    setApiError: (state, action: PayloadAction<RefundsState['apiError']>) => {
      state.apiError = action.payload;
    },
    clearApiError: (state) => {
      state.apiError = null;
    },
  },
});

export const { actions: refundsAction } = refundsSlice;

export default refundsSlice.reducer;
